import {
  SET_ALBARANES,
  SET_CAMIONES,
  SET_OBRAS,
  SET_TIPOS,
  SET_VERTEDEROS,
  SET_ALBARAN_PENDIENTE,
  SET_CARTAS_PORTE,
  SET_CARTA_PORTE_PENDIENTE,
  SET_MAQUINAS,
  SET_PLANTAS_ARIDO,
} from "../types/app.types";

const initialState = {
  albaranes: [],
  camiones: [],
  obras: [],
  tipos: [],
  vertederos: [],
  albaranPendiente: null,
  cartasPorte: [],
  cartaPortePendiente: null,
  maquinas: [],
  plantasArido: [],
};

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALBARANES: {
      if (action?.clearAlbaranPendiente) {
        return {
          ...state,
          albaranes: Array.isArray(action?.payload) ? [...action.payload] : [],
          albaranPendiente: null,
        };
      }
      return {
        ...state,
        albaranes: Array.isArray(action?.payload) ? [...action.payload] : [],
      };
    }
    case SET_CAMIONES: {
      return {
        ...state,
        camiones: Array.isArray(action?.payload) ? action.payload : [],
      };
    }
    case SET_OBRAS: {
      return {
        ...state,
        obras: Array.isArray(action?.payload) ? action.payload : [],
      };
    }
    case SET_TIPOS: {
      return {
        ...state,
        tipos: Array.isArray(action?.payload) ? action.payload : [],
      };
    }
    case SET_VERTEDEROS: {
      return {
        ...state,
        vertederos: Array.isArray(action?.payload) ? action.payload : [],
      };
    }
    case SET_ALBARAN_PENDIENTE: {
      return {
        ...state,
        albaranPendiente: action?.payload,
      };
    }
    case SET_CARTAS_PORTE: {
      if (action?.clearCartaPendiente) {
        return {
          ...state,
          cartasPorte: Array.isArray(action?.payload) ? [...action.payload] : [],
          cartaPortePendiente: null,
        };
      }
      return {
        ...state,
        cartasPorte: Array.isArray(action?.payload) ? [...action.payload] : [],
      };
    }
    case SET_CARTA_PORTE_PENDIENTE: {
      return {
        ...state,
        cartaPortePendiente: action?.payload,
      };
    }
    case SET_MAQUINAS: {
      return {
        ...state,
        maquinas: Array.isArray(action?.payload) ? action.payload : [],
      };
    }
    case SET_PLANTAS_ARIDO: {
      return {
        ...state,
        plantasArido: Array.isArray(action?.payload) ? action.payload : [],
      };
    }
    default:
      return state;
  }
};
